module.exports = __webpack_public_path__ + "static/media/paper-plane-solid.9b31ba45.svg";